var headerHeight = $('.header-wrapper-transparent').height(); 
$('.header-wrapper-transparent').css('margin-bottom', - headerHeight+'px');

$(window).on('resize',function(e) {
  var headerHeight = $('.header-wrapper-transparent').height(); 
  $('.header-wrapper-transparent').css('margin-bottom', - headerHeight+'px');
})


$('#tabs-nav li').click(function(){
  $('#tabs-nav li').removeClass('active');
  $(this).addClass('active');
   $(".tab-content").removeClass("circle-data-col-active");
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  $(activeTab).addClass('circle-data-col-active')  
  return false;
});



$('.review-slider').slick({
  infinite: true,
  slidesToShow: 1,
  adaptiveHeight: true,
   autoplay: true,
  arrows: false,
  dots: true,
  slidesToScroll:1
});

$(".product-block-list-item-inner").click(function(){
   $(this).toggleClass("accessories-popup");
});

$('.mobile-compare-dropdown .mobile-compare-dropdown-click').on('click',function(e) {
   $(this).closest('.product-table-item-img-right').removeClass('active');
   var id = $(this).data('id');
   $(this).closest('.product-table-main-mobile-header-col').find('.product-table-item-left[data-id="'+id+'"]').show();
   $(this).closest('.product-table-main-mobile-header-col').find('.product-table-item-left[data-id!="'+id+'"]').hide();
   var side = $(this).closest('.product-table-main-mobile-header-col').data('side');
   console.log(side);
   $('.product-table-main-mobile-inner [data-side="'+side+'"] .product-table-main-colum[data-id="'+id+'"]').show();
   $('.product-table-main-mobile-inner [data-side="'+side+'"] .product-table-main-colum[data-id!="'+id+'"]').hide(); 
})

$('.mobile-compare-list').on('click',function(e) {
   $(this).closest('.product-table-item-img-right').toggleClass('active'); 
})

setInterval(function(e) {
  var len = $('#tabs-nav li').length;
  var last = $('#tabs-nav li.active').data('index');    
  $('#tabs-nav li.active').each(function(e) {  
    var index = $(this).data('index');
    if(last == len){
     $(this).closest('ul').find('li').removeClass('active'); 
     $(this).closest('ul').find('li:first-child a').click();     
    }else{
     $(this).closest('ul').find('li').removeClass('active'); 
     console.log( $(this).next('li'))  ;
     $(this).next('li').find('a').click();  
    }    
  })  
},2500)
